import React, { useEffect, useMemo, useState } from 'react'
import api from '../../../service/api'
import { useSimbaAIStore } from '../../../store/simbaai.store'
import { Box, Button, Typography, useTheme } from '@mui/material'
import sleepingSimba from '../../../assets/simba-ai/sleeping.png'
import hurryingSimba from '../../../assets/simba-ai/hurrying.png'
import hidingSimba from '../../../assets/simba-ai/hiding.png'
import thumbsUpSimba from '../../../assets/simba-ai/thumbsup.png'
import runningSimba from '../../../assets/simba-ai/running.png'
import { observer } from 'mobx-react'
import { Icons } from '../../../utils/utilities'


const LatestPracticeStreak = observer( ( { parent = "simbaAIWindow" } ) => {

    const [loading, setLoading] = useState( true )

    const { palette, theme, layout, border } = useTheme()

    const SimbaAIStore = useSimbaAIStore()

    const streakHeadingStyles = useMemo( () => ( {
        background: parent === "simbaAIWindow" ? 'linear-gradient(90deg, #ff6a00, #ee0909ff)' : "initial",
        WebkitBackgroundClip: parent === "simbaAIWindow" ? 'text' : "initial",
        WebkitTextFillColor: parent === "simbaAIWindow" ? 'transparent' : "initial",
        backgroundClip: parent === "simbaAIWindow" ? 'text' : "initial",
        lineHeight: 1.1,
        fontWeight: "600",
        color: ( theme === 'dark' && parent === "simbaAIWindow" ) ? 'transparent' : palette.common.white,
        fontSize: parent === "simbaAIWindow" ? { sm: "28px", xs: "20px" } : "24px"
    } ), [parent, palette, theme] )

    const headingEmojiStyles = useMemo( () => ( {
        background: "none",
        fontSize: "inherit",
        fontWeight: "inherit",
        WebkitBackgroundClip: 'initial',
        WebkitTextFillColor: 'initial',
        backgroundClip: 'initial',
        color: '#ff6a00',
    } ), [parent, palette, theme] )

    useEffect( () => {
        SimbaAIStore.fetchLatestPracticeStreak()
        setLoading( false )
    }, [SimbaAIStore] )

    if ( !loading )
        return ( <Box padding="2px" borderRadius={parent === "simbaAIWindow" ? "10px" : layout.borderRadius} sx={{
            background: palette.primary.main + "22",
            border: `1px solid ${palette.primary.main}`,
        }} >
            <Box padding="5px 10px" borderRadius="10px" alignItems="center" display="flex" gap="20px">

                {/* INITIAL STREAK START */}
                {!SimbaAIStore.getLatestPracticeStreak.streakExists && parent === "simbaAIWindow" && <Box height="40px" component="img" src={hidingSimba} />}
                {!SimbaAIStore.getLatestPracticeStreak.streakExists && parent !== "simbaAIWindow" && <Box padding="10px" height="90px" width="90px" display="flex" alignItems="center" justifyContent="center" borderRadius="50% 50% 5px 50%" bgcolor={palette.common.white}>
                    <Box height="60px" component="img" src={hidingSimba} />
                </Box>}
                {!SimbaAIStore.getLatestPracticeStreak.streakExists && <Box>
                    <Typography variant='h4' fontSize="14px" color={palette.primary.main} component="h1" fontWeight={700} >Start your first streak today <Typography component="span" fontSize="inherit" lineHeight={1.1} sx={headingEmojiStyles} fontWeight="inherit" >🚀</Typography></Typography>
                    <Typography color={"textSecondary"} fontSize="12px" variant='subtitle2'>Practice daily to build momentum and keep your streak alive.</Typography>
                </Box>}

                {/* SKIPPED STREAK */}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && !SimbaAIStore.getLatestPracticeStreak.activeStreak && parent === "simbaAIWindow" && <Box height="40px" component="img" src={sleepingSimba} />}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && !SimbaAIStore.getLatestPracticeStreak.activeStreak && parent !== "simbaAIWindow" && <Box padding="10px" height="90px" width="90px" display="flex" alignItems="center" justifyContent="center" borderRadius="50% 50% 5px 50%" bgcolor={palette.common.white}>
                    <Box height="60px" component="img" src={sleepingSimba} />
                </Box>}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && !SimbaAIStore.getLatestPracticeStreak.activeStreak && <Box>
                    <Typography variant='h4' fontSize="14px" color={palette.primary.main} component="h1" fontWeight={700} >Oops! Your streak has fallen asleep <Typography component="span" fontSize="inherit" lineHeight={1.1} sx={headingEmojiStyles} fontWeight="inherit" >😴</Typography></Typography>
                    <Typography color={"textSecondary"} fontSize="12px" variant='subtitle2'>Complete a practice session to wake it up and get back on track.</Typography>
                </Box>}

                {/* ACTIVE STREAK, COMPLETED TODAY'S */}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && parent === "simbaAIWindow" && <Box height="40px" component="img" src={runningSimba} />}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && parent !== "simbaAIWindow" && <Box padding="10px" height="90px" width="90px" display="flex" alignItems="center" justifyContent="center" borderRadius="50% 50% 5px 50%" bgcolor={palette.common.white}>
                    <Box height="60px" component="img" src={runningSimba} />
                </Box>}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && <Box>
                    <Typography variant='h4' fontSize="14px" color={palette.primary.main} component="h1" fontWeight={700} >Amazing! You’re on a {SimbaAIStore.getLatestPracticeStreak?.latestStreak?.streak?.length}-day streak <Typography component="span" fontSize="inherit" lineHeight={1.1} sx={headingEmojiStyles} fontWeight="inherit" >🔥</Typography></Typography>
                    <Typography color={"textSecondary"} fontSize="12px" variant='subtitle2'>Keep the momentum going and see how far you can take it.</Typography>
                </Box>}

                {/* ACTIVE STREAK, YET TO COMPLETE TODAY'S */}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && !SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && parent === "simbaAIWindow" && <Box height="40px" component="img" src={hurryingSimba} />}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && !SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && parent !== "simbaAIWindow" && <Box padding="10px" height="90px" width="90px" display="flex" alignItems="center" justifyContent="center" borderRadius="50% 50% 5px 50%" bgcolor={palette.common.white}>
                    <Box height="60px" component="img" src={hurryingSimba} />
                </Box>}
                {SimbaAIStore.getLatestPracticeStreak.streakExists && SimbaAIStore.getLatestPracticeStreak.activeStreak && !SimbaAIStore.getLatestPracticeStreak.todaysStreakCompleted && <Box>
                    <Typography variant='h4' fontSize="14px" color={palette.primary.main} component="h1" fontWeight={700} >Your streak is counting on you <Typography component="span" fontSize="inherit" lineHeight={1.1} sx={headingEmojiStyles} fontWeight="inherit" >⏳</Typography></Typography>
                    <Typography color={"textSecondary"} fontSize="12px" variant='subtitle2'>Complete a practice today to keep your streak alive — don’t break the chain!</Typography>
                </Box>}
            </Box>

        </Box> )

    return null
} )

export default LatestPracticeStreak
